/* eslint-disable camelcase */
/* eslint-disable react/no-danger */
import AmpIncludeCustomElement from '@components/atoms/amp/AmpIncludeCustomElement';
import AmpWrap from '@components/atoms/amp/AmpWrap';
import BREAKPOINTS from '@lib/constants/breakpoints';
import styled from 'styled-components';
import Caption from './ImageWithCaption/Caption';

const Container = styled.div`
  width: 100%;

  .provider-YouTube {
    height: 400px;
    iframe {
      width: 100%;
      height: 100%;
    }

    @media screen and (max-width: ${BREAKPOINTS.medium}) {
      height: 300px;
    }
  }
`;

const EmbedSlice = ({
  slice : {primary: {caption,data}},
}: {
  slice: {
    primary: {
      data?: {
        height: number;
        width: number;
        embed_url: string;
        type: string;
        version: string;
        title: string;
        author_name: string;
        author_url: string;
        provider_name: 'YouTube';
        provider_url: string;
        cache_age: any;
        thumbnail_url: string;
        thumbnail_width: number;
        thumbnail_height: number;
        html: string;
      };
      caption?: string;
    };
  };
}) => {
  if (!data) return null;

  return (
    <Container>
      <AmpWrap
        nonAmp={
          <div
            className={`provider-${data.provider_name}`}
            dangerouslySetInnerHTML={{ __html: data.html }}
          />
        }
        ampOnly={
          <>
            {data.provider_name === 'YouTube' && (
              <>
                <AmpIncludeCustomElement
                  name="amp-youtube"
                  version="0.1"
                />
                <amp-youtube
                  width="480"
                  height="270"
                  layout="responsive"
                  data-videoid={data.embed_url
                    ?.match(/([a-z0-9_-]{11})/gim)
                    ?.shift()}
                />
              </>
            )}
          </>
        }
      />
      {caption && <Caption caption={caption} />}
    </Container>
  );
};

export default EmbedSlice;
